"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = hideSeriesLegendClickHandlerFactory;

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.find-index");

var _coerce = _interopRequireDefault(require("@meltwater/coerce"));

var _mwChartNSeriesLineOptions = _interopRequireDefault(require("../../mw-chart-n-series-line/mw-chart-n-series-line-options"));

var _seriesData = _interopRequireDefault(require("../../series-data"));

/**
 * Produces a legend click handler that will handle hiding or showing series
 *
 * @param {SeriesData[]} seriesData - The series that will be hidden or shown on legend click
 * @param {MwChartNSeriesLineOptions} chartOptions - The chart options being applied to the chart
 *
 * @returns {MwChartNSeriesLineLegendClickHandler} An function that will hide/show a series when legend is clicked
 */
function hideSeriesLegendClickHandlerFactory(seriesData, chartOptions) {
  seriesData.forEach(function (series) {
    return (0, _coerce.default)(series, _seriesData.default, "seriesData must be an array of items coercable to SeriesData. Provided value: ".concat(JSON.stringify(seriesData)));
  });
  (0, _coerce.default)(chartOptions, _mwChartNSeriesLineOptions.default, "chartOptions must be coercable to MwChartNSeriesLineOptions. Provided value: ".concat(JSON.stringify(chartOptions)));
  var ownedCopyOfHiddenSeriesIndices = JSON.parse(JSON.stringify(chartOptions.hiddenSeriesIndices));
  return function (_ref) {
    var seriesName = _ref.seriesName,
        chart = _ref.chart;
    var seriesIndex = seriesData.findIndex(function (series) {
      return series.name === seriesName;
    });

    if (seriesIndex === -1) {
      return;
    }

    var indexInHiddenSeriesIndices = ownedCopyOfHiddenSeriesIndices.indexOf(seriesIndex);

    if (indexInHiddenSeriesIndices === -1) {
      ownedCopyOfHiddenSeriesIndices.push(seriesIndex);
    } else {
      ownedCopyOfHiddenSeriesIndices.splice(indexInHiddenSeriesIndices, 1);
    }

    chart.updateHiddenSeriesIndices(ownedCopyOfHiddenSeriesIndices);
  };
}